// extracted by mini-css-extract-plugin
export var applyBtn = "filter-group-module--apply-btn--8fcd1";
export var applyInput = "filter-group-module--apply-input--1faa1";
export var arrow = "filter-group-module--arrow--ea5b7";
export var button = "filter-group-module--button--2cd51";
export var cafeFormIntro = "filter-group-module--cafe-form-intro--edcaf";
export var checkBox = "filter-group-module--check-box--ad863";
export var clear = "filter-group-module--clear--70b57";
export var close = "filter-group-module--close--c2e94";
export var closeWrapper = "filter-group-module--close-wrapper--2dd8b";
export var desktopFilter = "filter-group-module--desktop-filter--60bd8";
export var filterBy = "filter-group-module--filter-by--8e25c";
export var filterCheckbox = "filter-group-module--filter-checkbox--3c1a2";
export var filterCheckboxContainer = "filter-group-module--filter-checkbox-container--792b3";
export var filterGroups = "filter-group-module--filter-groups--b6573";
export var filterHeadDesktop = "filter-group-module--filter-head-desktop--7828e";
export var filterHeadMobile = "filter-group-module--filter-head-mobile--a5417";
export var filterHeadMobilePopUp = "filter-group-module--filter-head-mobile-pop-up--15bd5";
export var filterInput = "filter-group-module--filter-input--2c8e1";
export var filterPopUp = "filter-group-module--filter-pop-up--44a1c";
export var filterSecond = "filter-group-module--filter-second--39025";
export var filterSecondMobile = "filter-group-module--filter-second-mobile--5a8c7";
export var filterTitle = "filter-group-module--filter-title--dc883";
export var filterTitleGrey = "filter-group-module--filter-title-grey--7cea3";
export var filters = "filter-group-module--filters--53aa0";
export var highlight = "filter-group-module--highlight--93d88";
export var mobileFilter = "filter-group-module--mobile-filter--498c4";
export var redButton = "filter-group-module--red-button--c66e2";
export var redTransparentButton = "filter-group-module--red-transparent-button--bc788";
export var transparentButton = "filter-group-module--transparent-button--de065";